module.exports = __webpack_public_path__ + "img/device.fae88a6e.png";